<template>
  <div class="titlebar">
    <div class="lb"></div>
    <div class="title">{{title}}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "我的作品",
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.titlebar {
  display: flex;
  align-items: center;
  .lb {
    width: 10px;
    height: 20px;
    border-radius: 10px;
    background-color: #16224D;
  }
  .title {
    margin-left: 40px;
    font-size: 20px;
    font-weight: bold;
    color: #16224D;
  }
}
</style>
